module.exports = __webpack_public_path__ + "img/result-detail-communication-inleft03.ff9965c8.svg";